/**
 * our harriApp passed to the function
 *
 * @type {Object} harriApp
 * @namespace RejectionTemplatesSettings
 */
(function (app) {
    "use strict";

    /**
     * @typedef {Object} RejectionTemplatesSettingsController
     */

    /**
     * Construct a new RejectionTemplatesSettingsController
     *
     * @class RejectionTemplatesSettingsController
     * @classdesc rejection template setting view.
     *
     * @param $scope
     * @param $alert
     * @param $state
     * @param Upload
     * @constructor
     */
    var RejectionTemplatesSettingsController = function ($scope, $alert, $state, Upload, hUser, userServices) {
        var self = this;

        /**
         * This to show the success message
         *
         * @param message
         */
        var successAlert = function (message) {
            $alert({
                content: message,
                placement: 'top',
                type: 'success',
                show: true,
                container: '.rejection-templates-settings-form',
                templateUrl: "../modules/rejection-templates/save-rejection-templates-settings-form.html",
                duration: 3
            });
        };

        /**
         * Handle error alert for every error on this component
         * @param errorMessage
         * @param callback
         */
        var errorAlert = function (errorMessage, callback) {
            callback = callback || function () {
            };

            var errorBody = '<p>' + $filter("translate")("Something went wrong please try again later") + '</p>';

            if (errorMessage) {
                errorBody += '<p>' + JSON.stringify(errorMessage) + '</p>';
            }

            errorBody += '<p>' + $filter("translate")("For questions you can reach us at 844.HARRI.HELP (844.427.7443).") + '</p>';
            hAlert(
                $filter('translate')('Something went wrong!'),
                $filter('translate')(errorBody),
                function () {
                    callback();
                },
                'rejection-templates-error-alert'
            );
        };

        /**
         * The initial point for this component to load template for job view
         */
        var onInit = function () {
            /**
             * Rejection templates data
             * @type {{}}
             */
            self.rejectionTemplates = {};
            self.systemRejectionTemplates = {};

            self.loading = true;

            var promises = {};

            /**
             * get System rejection templates
             */
            promises['systemRejectionTemplates'] = BrandAPI.getSystemRejectionTemplates();
            /**
             * get rejection templates
             *
             */
            promises['brandRejectionTemplates'] = BrandAPI.getBrandRejectionTemplates(self.brandId, 'OWNED');
            promises['rejectionTemplatesPoolId'] = BrandAPI.getRejectionTemplatePoolId(self.brandId);
            $q.all(promises)
                .then(function (result) {
                    self.systemRejectionTemplates = result.systemRejectionTemplates;
                    self.pool_id = result.rejectionTemplatesPoolId.pool_id;

                    var brandTemplates = result.brandRejectionTemplates.message_templates;
                    /**
                     * attach these template to view using rejectionTemplates object
                     */
                    for (var i in brandTemplates) {
                        var template = brandTemplates[i];
                        template.updated = new Date(template.updated);
                        self.rejectionTemplates[template.id] = template;
                    }

                    /**
                     * To show empty rejection templates message on setting
                     */
                    self.rejectionTemplatesNumber = brandTemplates.length;

                    self.loading = false;
                    $scope.$digest();
                }, function (err) {
                    /**
                     * Handle error
                     */
                    if (err.data && err.data.status_code === 403) {
                        $state.go('404');
                    } else {
                        errorAlert(err);
                    }
                });

        };


        /**
         * Handle success event when add new item or edit the items
         * @param item
         */
        self.onSuccessManageItems = function (item) {
            self.rejectionTemplates[item.id] = item;
            self.rejectionTemplatesNumber = Object.keys(self.rejectionTemplates).length;

            var message = $filter('translate')('Template was created successfully');

            if (!item.newItem) {
                message = $filter('translate')('Template was updated successfully');
            }

            successAlert(message);
        };

        /**
         * Show manage modal to add or edit
         * @param item
         * @param viewType
         */
        self.showManageModalAction = function (item, viewType) {
            self.showManageModal = true;

            if (item) {
                item.viewOnly = viewType === 'VIEW_ONLY';
                item.isSystemTemplate =  viewType === 'SYSTEM_TEMPLATE';
                item.message_template_pool_id =  self.pool_id;
            }
            else {
                item = {
                    message_template_pool_id: self.pool_id
                };
            }

            self.selectedRejectionTemplate = item;
        };

        /**
         * Add  selected system template
         * @param item
         */
        self.addRejectionTemplate = function (item) {
            if (item) {
                item.message_template_pool_id =  self.pool_id;
            }
            delete item.id;
            var url = publicConfiguration.APIServerBaseURL + 'brands/' + self.brandId + '/message_templates';
            var method = 'POST';

            self.addingTemplate = true;
            /**
             * This ng-upload service to request API using multipart request
             * there is two promise callback fail and success
             * the fail one show a modal told the user that we have error or something went wrong
             */
            Upload.upload({
                'url':  url,
                'withCredentials': true,
                'headers': {},
                'method': method,
                'data': item,
                'Content-Type': 'multipart/form-data',
                'arrayKey': '[]'
            }).progress(function (evt) {
            }).success(function (data, status, headers, config) {
                if (data.status_code == 200) {

                    data.data.updated = new Date(data.data.updated);
                    self.onSuccessManageItems(data.data);
                } else {
                    var errorBody = '';

                    if (data && data.data && Array.isArray(data.data)) {
                        for (var i in data.data) {
                            if (data.data[i].error) {
                                errorBody += '<p class="capitalize"><b>' + $filter("translate")(data.data[i].error) + '</b></p>';
                            }
                        }
                    }

                    hAlert(
                        $filter('translate')('Something went wrong!'),
                        $filter('translate')(errorBody) || '<p>' + JSON.stringify($filter("translate")(data.data)) + '</p>',
                        function () {},
                        'rejection-templates-error-alert'
                    );
                }

                self.loading = false;
                self.addingTemplate = false;
            }).error(function (reason) {
                hAlert(
                    $filter('translate')('Something went wrong!'),
                    '<pre>' + JSON.stringify($filter('translate')(reason)) + '</pre>',
                    function () {},
                    'rejection-templates-error-alert'
                );

                self.loading = false;
                self.addingTemplate = false;
            });
        };

        /**
         * Handle hide modal event
         */
        self.onHideManageModal = function () {
            self.showManageModal = false;
            delete self.selectedRejectionTemplate;
        };

        /**
         * Handle delete rejection template item on the rejection modal
         * @param id
         */
        self.onDeletedItem = function (id) {
            delete self.rejectionTemplates[id];
            self.rejectionTemplatesNumber = Object.keys(self.rejectionTemplates).length;
        };

        /**
         * The remove button on rejection template
         * @param id
         */
        self.removeRejectionTemplate = function (id) {
            hConfirm({
                text: $filter("translate")("Are you sure you want to delete this template?"),
                callback: function (confirmed) {
                    if (confirmed) {
                        self.loading = true;

                        BrandAPI.deleteBrandRejectionTemplate(self.brandId, id)
                            .then(function () {
                                delete self.rejectionTemplates[id];

                                self.rejectionTemplatesNumber = Object.keys(self.rejectionTemplates).length;
                                successAlert('Template was deleted successfully');
                                self.loading = false;
                                $scope.$digest();
                            }, function (err) {
                                self.loading = false;
                                $scope.$digest();

                                hAlert(
                                    $filter('translate')('Something went wrong!'),
                                    $filter('translate')(err),
                                    function () {},
                                    'rejection-templates-error-alert'
                                );
                            });
                    }
                }
            });
        };

        /**
         * Called on each controller after all the controllers on an element
         *
         * @type {Function[]}
         */
        self.$onInit = function () {
            if (typeof (self.brandId) !== 'undefined') {
                onInit();
            }
        };

        /**
         * Called whenever one-way bindings are updated
         *
         * @param changesObj
         * @param {Number} changesObj.brandId
         */
        self.$onChanges = function (changesObj) {
            if (
                !changesObj.brandId.isFirstChange() &&
                JSON.stringify(changesObj.brandId.currentValue) !== JSON.stringify(changesObj.brandId.previousValue)
            ) {
                onInit();
            }
        };
    };

    /**
     *
     * @type {Object}
     */
    var RejectionTemplatesSettings = {
        bindings: {
            brandId: '<'
        },
        templateUrl: '../modules/rejection-templates/components/rejection-templates-settings/rejection-templates-settings.html',
        controller: ['$scope', '$alert', '$state', 'Upload', 'hUser', 'userServices', RejectionTemplatesSettingsController],
        controllerAs: 'RejectionTemplatesSettings'
    };

    app.component('rejectionTemplatesSettings', RejectionTemplatesSettings);
})(angular.module('harriApp.rejectionTemplates'));